import { useEffect, useState } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';

import { useTranslation } from 'react-i18next';
import Tabs from '../../../../Template/layoutComponents/Tabs';

import HistoryTab from '../../../../Template/layoutComponents/HistoryTab';
import GeneralTab from '../../../../Template/layoutComponents/GeneralTab';
import { updateCostCenter, updateDepartment } from '../../../../Maintenance/helpers/apiCalls';
import useSettingsState from '../../../atoms/variables';

import useMaintenanceState from '../../../../Maintenance/atoms/variables';

import { getCostCenters } from '../../../../Maintenance/helpers/apiCalls';
import { notification } from 'antd';
import useTemplateState from '../../../../Template/atoms/variables';
import { useMsal } from '@azure/msal-react';

const Details = () => {
  const { t } = useTranslation();
  const [notificationApi, contextHolder] = notification.useNotification();
  const { instance } = useMsal();
  const { categoryId } = useParams();

  const { setCostcenters } = useMaintenanceState();
  const { setPendingApiCalls } = useTemplateState();
  const { viewDetailsCategory, setViewDetailsCategory } = useSettingsState();

  useEffect(() => {
    if (!viewDetailsCategory) {
      triggerApiCalls();
    }
  }, []);

  const triggerApiCalls = async () => {
    try {
      setPendingApiCalls((current) => current.concat(['getCostCenters']));

      const response = await getCostCenters(instance);
      setCostcenters(response);
      setViewDetailsCategory(response?.find((c) => c.id === categoryId || c._id === categoryId));
    } catch (err) {
      notificationApi.error({
        message: t('database_communication_failure'),
        description: err?.response?.data?.message
          ? `${err?.response?.data?.message} (${err?.response?.status})`
          : err?.message,
        duration: 5,
      });
    } finally {
      setPendingApiCalls((current) => current.filter((item) => item !== 'getCostCenters'));
    }
  };

  return (
    <div id='categoryDetails'>
      {contextHolder}
      <Tabs
        tabs={[
          {
            label: t('general_tab'),
            content: (
              <GeneralTab
                noEditing={true}
                detailsLink={'/settings/cost-centers'}
                updateItem={updateCostCenter}
              />
            ),
            disabled: false,
          },
          {
            label: t('history_tab'),
            content: <HistoryTab id={categoryId} />,
            disabled: false,
          },
        ].filter((tab) => tab)}
      />
    </div>
  );
};

export default Details;
